import { useQuery } from "@tanstack/react-query"
import { getProfile } from "../services/profileService"

export const useProfile = (userId?: number, token?: string | null) => {
    return useQuery({
        queryKey: ['profile', userId],
        queryFn: () => getProfile(userId!, token!),
        enabled: !!userId && !!token,
        staleTime: 1000 * 60 * 30, // 30 menit refetch
        gcTime: 1000 * 60 * 30 // 30 menit disimpan
    })
}